import { FETCH_EXPIRATIONS } from '../../actions';
import createSingleResourceReducer from 'shared/app/stale-reducers/single-resource-reducer';

export default createSingleResourceReducer({ startAction: FETCH_EXPIRATIONS })
  .reducer;
